module.exports = __webpack_public_path__ + "static/media/mail.d002a777.png";